//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WX_API from '@/utils/wx_api'
export default {
    data() {
        return {}
    },
    props: {
        loading: Boolean,
        result: Object,
        show_result: Object,
        show_price: {
            type: Boolean,
            default: true
        },
        show_join_group: Boolean,
        hide_comment_btn: Boolean,
        go_comment_lock: Boolean,
        house:Object,
        building_name:String
    },
    computed: {
        show_img_result() {
            return this.result && this.result.ln_result && this.result.ln_result.length
        },
        ln_num() {
            return this.show_img_result ? this.result.ln_number : ''
        },
        show_house_price () {
            const exist_values = this.house.exist_values || []
            return exist_values.includes('house_prices') && this.show_price
        },
        show_share_comment_btn(){
            return !this.hide_comment_btn && this.show_result.show_content && this.content
        },
        btn_num(){
            return [this.show_share_comment_btn, this.show_house_price].filter(v => v).length
        },
        order() {
            let arr = []
            this.result.ln_result.forEach((rs) => {
                arr.push(`${rs.ln_type}第${rs.ln_order}号`)
            })
            return arr.join(',')
        },
        content() {
            const { ln_result } = this.result
            let _content = ''
            if (ln_result && ln_result.length) {
                const new_arr = this.result.ln_result.sort((a, b) => {
                    return Number(a.wish_discard_persons) - Number(b.wish_discard_persons)
                })
                _content = new_arr[0].share_desc
            }
            return _content
        }
    },
    methods: {
        toggleTip() {
            if (this.show_result.show_qa) {
                this.$emit('toggleTip')
            }
        },
        async drawImg() {
            if (this.go_comment_lock) return
            this.$sendCtmEvtLog('摇号结果页点击-分享到评论')
            this.$emit('setLock')
            const canvasId = 'lottery-result-canvas'
            const bg_img = this.show_result.is_success ? 'https://cdn.vip-wifi.com/fangchan/img/mine_detail/draw-img-good.png' : 'https://cdn.vip-wifi.com/fangchan/img/mine_detail/draw-img-normal.png'
            const ctx = wx.createCanvasContext(canvasId, this.$mp.component)
            const { path: bgImg} = await WX_API.getImgInfo(bg_img)
            const { path: qrImg }= await WX_API.getImgInfo(this.show_result.qr_img)
            const CANVAS_WIDTH = 343
            const CANVAS_HEIGHT = 345
            const _LEFT = CANVAS_WIDTH /2

            // draw photo
            ctx.drawImage(bgImg, 0, 0, CANVAS_WIDTH, CANVAS_HEIGHT)

            if (this.show_result.is_success) {
                this.drawContent(ctx, _LEFT, '#FFFFFF', '#CC3D0B')
            } else {
                this.drawContent(ctx, _LEFT, '#333333', '#333333')
            }

            // draw qr img
            ctx.drawImage(qrImg, _LEFT - 34, 240, 68, 68)
            ctx.setTextAlign('center')
            ctx.font = 'normal 12px PingFang SC'
            ctx.setFillStyle('#FFFFFF')
            ctx.fillText('扫码我也要查', _LEFT, 325)

            ctx.draw(true, () => {
                setTimeout(() => {
                    this.downImg(canvasId, CANVAS_WIDTH, CANVAS_HEIGHT)
                }, 100)
                })
        },
        drawContent(ctx, _LEFT, title_color, body_color) {
            // draw num
            ctx.setFillStyle(title_color)
            ctx.setTextAlign('center')
            ctx.font = 'normal 14px PingFang SC'
            ctx.fillText(`公证摇号编码`, _LEFT, 75)
            ctx.font = 'normal bold 20px PingFang SC'
            ctx.fillText(`${this.ln_num}`, _LEFT, 100)

            //draw rect
            ctx.setFillStyle('#F6F6F6')
            ctx.fillRect(39, 120, 265, 24)

            //draw buldingName
            ctx.setFillStyle('#999')
            ctx.setTextAlign('center')
            ctx.font = 'normal 14px PingFang SC'
            ctx.fillText(`楼盘：${this.building_name}`,_LEFT, 136)

            // draw order
            ctx.setFillStyle(body_color)
            ctx.setTextAlign('center')
            ctx.font = 'normal bold 18px PingFang SC'
            ctx.fillText(this.order, _LEFT, 170)

            // draw desc
            ctx.setFillStyle(body_color)
            ctx.setTextAlign('center')
            ctx.font = 'normal 14px PingFang SC'
            ctx.fillText(this.show_result.desc, _LEFT, 195)
        },
        downImg(canvasId, CANVAS_WIDTH, CANVAS_HEIGHT) {
            wx.canvasToTempFilePath(
                {
                    canvasId,
                    width: CANVAS_WIDTH,
                    height: CANVAS_HEIGHT,
                    x: 0,
                    y: 0,
                    success: async (res) => {
                        const url = await WX_API.uploadImg(res.tempFilePath)
                        this.$emit('goComment', url, this.content)
                    },
                    fail: () => {
                        this.unLock()
                        wx.showToast({
                            title: '上传出错啦~',
                            icon: 'none'
                        })
                    }
                },
                this.$mp.component
            )
        },
        goHousePrice(){
            const { building_id, name, id } = this.house
            wx.navigateTo({
                url: `/building/price?building_id=${building_id}&title=${name}&house_id=${id}`
            })
        },
        joinGroup () {
            this.$emit('joinGroup')
        }
    }
}
